import { TwoStepRegistration } from './TwoStepRegistration.js';
export default TwoStepRegistration;
//# sourceMappingURL=index.js.map